// @flow
import React from 'react'
import './styles.scss'
// https://reactjsexample.com/a-very-simple-echarts-wrapper-for-react/
import ReactEcharts from 'echarts-for-react'
import echarts from 'echarts'
import { Link } from '@ta-interaktiv/contentbricks'

const monthNames = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember'
]

const months = [
  'Jan',
  'Feb',
  'Mär',
  'Apr',
  'Mai',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Okt',
  'Nov',
  'Dez'
]

// Generate mock data
// const data = []
// const dataCount = 157
/*
echarts.util.each(months, function(category, index) {
  for (let i = 0; i < dataCount; i++) {
    const typeItem = types[Math.round(Math.random() * (types.length - 1))]
    const year = 1864
    data.push({
      name: typeItem.name,
      value: [index, year, year + 1, 1],
      itemStyle: {
        normal: {
          color: typeItem.color
        }
      }
    })
  }
  console.log('### MOCK DATA ###', data)
})
*/

let stripeMargin = 0.5

function renderItem(params, api) {
  const categoryIndex = api.value(0)
  const start = api.coord([api.value(1), categoryIndex])
  const end = api.coord([api.value(2), categoryIndex])
  const height = api.size([0, 1])[1] * 0.97

  const rectShape = echarts.graphic.clipRectByRect(
    {
      x: start[0],
      y: start[1] - height / 2,
      width: end[0] - start[0] - stripeMargin,
      height: height
    },
    {
      x: params.coordSys.x,
      y: params.coordSys.y,
      width: params.coordSys.width,
      height: params.coordSys.height
    }
  )

  return (
    rectShape && {
      type: 'rect',
      shape: rectShape,
      style: api.style()
    }
  )
}

export class GlobalStripes extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      isMobile: window.innerWidth < 650,
      isTablet: window.innerWidth < 800,
      displayData: {},
      chartOptions: {},
      echartInstance: null,
      referencePeriod: '1981-2010', // 1961-1990,
      highlightItem: -1,
      highlightTemp: 9999,
      zoomStart: -1,
      zoomEnd: -1
    }
    this.handleEvents = {
      dataZoom: this.onZoom,
      mouseout: this.onChartLeave
    }
  }

  onZoom = params => {
    // console.log('+++++ params ++++')
    // console.log(params)
    // console.log('start: ', params.start)
    // console.log('end: ', params.end)
    const zoomRange = params.end - params.start
    // console.log('zoomRange:', zoomRange)
    // console.log('zoom stripeMargin:', stripeMargin)
    stripeMargin = this.state.isMobile ? 0 : zoomRange / 200

    this.setState({
      zoomStart: params.start,
      zoomEnd: params.end
    })
  }

  onChartLeave = params => {
    // console.log('+++++ params ++++')
    // console.log(params)
    this.setState(
      {
        highlightItem: -1
      },
      () => {
        // console.log('#### highlightItem ####', this.state.highlightItem)
        this.state.echartInstance.setOption(this.getOption())
      }
    )
  }

  componentDidMount() {
    // prepare Data according to set lastMonth
    const lastMonth = this.props.lastMonth.replace('-', '').toString()
    let displayData = this.props.data
    const monthIndex = this.props.data.findIndex(x => x.Month === lastMonth)
    if (monthIndex >= 0) {
      displayData = this.props.data.slice(0, monthIndex + 1)
    }
    this.setState({ displayData: displayData }, () => {
      this.setState(
        {
          chartOptions: this.getOption()
        },
        () => {
          this.setState({
            echartInstance: this.echarts_react.getEchartsInstance()
          })
        }
      )
    })
  }

  setHighlight(highlightTemp) {
    // console.log('highlightTemp:', this.state.highlightTemp)
    // console.log('zoom start:', this.state.zoomStart)
    // console.log('zoom start:', this.state.zoomEnd)
    this.setState(
      {
        highlightTemp: highlightTemp
      },
      () => {
        this.state.echartInstance.setOption(this.getOption())
      }
    )
  }

  formatData(data) {
    // console.log('DATA VALUES: ', data)
    const allMonths = []
    let itemIndex = 0
    const yearCount = Math.ceil(data.length / 12)
    // console.log('yearCount: ', yearCount)
    for (let i = 0; i < months.length; i++) {
      for (let y = 0; y < yearCount; y++) {
        // console.log('itemIndex: ', itemIndex)
        let currItem = {}
        let typeItem = {}
        let year = -1
        let currDelta = -999
        if (data[y * 12 + i] != undefined) {
          currDelta = parseFloat(data[y * 12 + i].global)
          year = data[y * 12 + i].Month.toString().substring(0, 4)
          typeItem = this.defineType(currDelta, this.state.highlightTemp)
          // console.log('currDelta', currDelta)
          // console.log('curr highlightTemp: ', this.state.highlightTemp)
        } else {
          // no value in data for that month
          typeItem = this.defineType(null, this.state.highlightTemp)
        }
        currItem = {
          name: typeItem.name,
          value: [i, parseInt(year), parseInt(year) + 1, 1, currDelta],
          itemStyle: {
            normal: {
              color: typeItem.color,
              borderColor:
                itemIndex === this.state.highlightItem
                  ? '#00FCFF'
                  : 'transparent',
              borderWidth: itemIndex === this.state.highlightItem ? 2 : 0
            }
          }
        }
        // console.log('currItem:', currItem)
        allMonths.push(currItem)
        itemIndex++
      }
    }
    // console.log('°°°°° allMonths °°°°°')
    // console.log(allMonths)
    return allMonths
  }

  defineType(temperature, highlightTemp) {
    // console.log('temperature:', temperature)
    // console.log('highlightTemp:', highlightTemp)
    if (temperature === undefined) {
      return { name: 'NO DATA', color: '#333333' }
    } else {
      if (temperature < -1.5) {
        return {
          name: 'unter -1.5°',
          color:
            highlightTemp === 9999 || highlightTemp < -1.5
              ? '#081f45'
              : '#1f1f1f'
        }
      } else if (temperature >= -1.5 && temperature < -1.25) {
        return {
          name: '-1.5° bis -1.25°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -1.5 && highlightTemp < -1.25)
              ? '#4c7da8'
              : '#1f1f1f'
        }
      } else if (temperature >= -1.25 && temperature < -1) {
        return {
          name: '-1.25° bis -1°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -1.25 && highlightTemp < -1)
              ? '#366492'
              : '#1f1f1f'
        }
      } else if (temperature >= -1 && temperature < -0.75) {
        return {
          name: '-1° bis -0.75°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -1 && highlightTemp < -0.75)
              ? '#6697bd'
              : '#1f1f1f'
        }
      } else if (temperature >= -0.75 && temperature < -0.5) {
        return {
          name: '-0.75° bis -0.5°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -0.75 && highlightTemp < -0.5)
              ? '#83b0cf'
              : '#1f1f1f'
        }
      } else if (temperature >= -0.5 && temperature < -0.25) {
        return {
          name: '-0.5° bis -0.25°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -0.5 && highlightTemp < -0.25)
              ? '#a3cadf'
              : '#1f1f1f'
        }
      } else if (temperature >= -0.25 && temperature < -0.125) {
        return {
          name: '-0.25° bis -0.125°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -0.25 && highlightTemp < -0.125)
              ? '#c8e3ef'
              : '#1f1f1f'
        }
      } else if (temperature >= -0.125 && temperature <= 0) {
        return {
          name: '-0.125° bis 0°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= -0.125 && highlightTemp <= 0)
              ? '#f1fcff'
              : '#1f1f1f'
        }
      } else if (temperature > 0 && temperature < 0.125) {
        return {
          name: '0° bis 0.125°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp > 0 && highlightTemp < 0.125)
              ? '#ffffe1'
              : '#1f1f1f'
        }
      } else if (temperature >= 0.125 && temperature < 0.25) {
        return {
          name: '0.125° bis 0.25°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= 0.125 && highlightTemp < 0.25)
              ? '#fed5a0'
              : '#1f1f1f'
        }
      } else if (temperature >= 0.25 && temperature < 0.5) {
        return {
          name: '0.25° bis 0.5°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= 0.25 && highlightTemp < 0.5)
              ? '#fda67a'
              : '#1f1f1f'
        }
      } else if (temperature >= 0.5 && temperature < 0.75) {
        return {
          name: '0.5° bis 0.75°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= 0.5 && highlightTemp < 0.75)
              ? '#ef7967'
              : '#1f1f1f'
        }
      } else if (temperature >= 0.75 && temperature < 1) {
        return {
          name: '0.75° bis 1°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= 0.75 && highlightTemp < 1)
              ? '#d45059'
              : '#1f1f1f'
        }
      } else if (temperature >= 1 && temperature < 1.25) {
        return {
          name: '1° bis 1.25°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= 1 && highlightTemp < 1.25)
              ? '#b22d45'
              : '#1f1f1f'
        }
      } else if (temperature >= 1.25 && temperature < 1.5) {
        return {
          name: '1.25° bis 1.5°',
          color:
            highlightTemp === 9999 ||
            (highlightTemp >= 1.25 && highlightTemp < 1.5)
              ? '#8a102b'
              : '#1f1f1f'
        }
      } else if (temperature >= 1.5) {
        return {
          name: '>1.5°',
          color:
            highlightTemp === 9999 || highlightTemp >= 1.5
              ? '#5e0204'
              : '#2E2E2E'
        }
      } else {
        // console.log('!!! ERROR !!!')
        return { name: 'ERROR', color: '#00ff00' }
      }
    }
  }

  // Chart Options
  // https://ecomfe.github.io/echarts-doc/public/en/option.html#title
  getOption() {
    return {
      tooltip: {
        backgroundColor: '#f3f3f3',
        formatter: function(params, ticket, callback) {
          // console.log('#### params ####', params)
          this.setState(
            {
              highlightItem: params.dataIndex
            },
            () => {
              // console.log('#### highlightItem ####', this.state.highlightItem)
              this.state.echartInstance.setOption(this.getOption())
            }
          )
          const monthIndex = params.value[0]
          const currMonth = monthNames[monthIndex]
          const currYear = params.value[1]
          const firstYear = parseFloat(
            this.state.displayData[0].Month.toString().substring(0, 4)
          )
          const currYearIndex = currYear - firstYear
          const currDiff = parseFloat(params.value[4]).toFixed(2)
          const displayDiff = currDiff > 0 ? '+' + currDiff : currDiff
          const title =
            '<div class="tip-title"><strong>' +
            currMonth +
            '</strong> | ' +
            currYear +
            '</div>'

          let tooltipContent = title + '<hr class="under" />'
          tooltipContent += '<div class="row">'
          tooltipContent += 'Abweichung:  '
          tooltipContent +=
            '<span class="weighted">' +
            displayDiff +
            ' °C</span><br />vom langjährigen Mittel</div>'

          // callback(console.log('scrubbed to: ', params[0].dataIndex))
          if (currDiff !== null && currDiff !== undefined) {
            return tooltipContent
          }
        }.bind(this)
      },
      dataZoom: [
        {
          type: 'slider',
          filterMode: 'filter',

          start: this.state.zoomStart >= 0 ? this.state.zoomStart : 0,
          end: this.state.zoomEnd >= 0 ? this.state.zoomEnd : 100, // 20 years range

          minValueSpan: 20,
          maxValueSpan: Math.ceil(this.state.displayData.length / 12), // 42
          labelPrecision: 10,
          showDataShadow: false,
          bottom: 20,
          height: 10,
          left: 15,
          right: 30,
          borderColor: 'transparent',
          backgroundColor: '#222222',
          handleIcon: 'image://' + require('./images/handle.svg'),
          handleSize: 20,
          labelFormatter: ''
        }
      ],
      grid: [
        {
          top: this.state.isMobile ? '5%' : '5%',
          left: 15,
          right: 0,
          bottom: 40,
          containLabel: true
        }
      ],
      xAxis: {
        min: parseInt(this.state.displayData[0].Month.toString().substring(0, 4)), // 1979
        max:
          parseInt(
            this.state.displayData[
              this.state.displayData.length - 1
            ].Month.toString().substring(0, 4)
          ) + 1, // 2021
        position: 'top',
        scale: true,
        axisLabel: {
          formatter: function(params) {
            // return parseInt(params)
            return params
          },
          position: 'left',
          padding: [0, 0, 0, 2],
          color: '#ffffff',
          showMaxLabel: false,
          showMinLabel: false
        },
        axisTick: {
          show: true,
          alignWithLabel: true,
          lineStyle: {
            color: '#ffffff'
          }
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        inverse: true,
        position: 'right',
        data: months,
        axisLabel: {
          verticalAlign: 'middle',
          padding: [0, 0, -1, 0],
          color: '#ffffff'
        }
      },
      series: [
        {
          type: 'custom',
          renderItem: renderItem,
          itemStyle: {
            opacity: 1
          },
          encode: {
            x: [1, 2],
            y: 0
          },
          data: this.formatData(this.state.displayData),
          animation: false
        }
      ]
    }
  }

  render() {
    // console.log('### DATA ###', this.state.displayData)
    // register theme object
    // theme object format example: https://github.com/apache/incubator-echarts/blob/master/theme/dark.js
    echarts.registerTheme('ta_theme', {
      backgroundColor: 'transparent',
      textStyle: {
        fontSize: '16',
        fontFamily:
          'TamediaChart,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif',
        color: '#333'
      },
      title: {
        textStyle: {
          color: '#333',
          fontSize: '22'
        },
        subtextStyle: {
          color: '#5f5f5f',
          fontSize: '18'
        }
      },
      legend: {
        left: 'left',
        orient: 'vertical',
        itemGap: 7,
        padding: [0, 0, 0, 10],
        itemWidth: 10,
        textStyle: {
          fontSize: '16'
        },
        show: false
      },
      label: {
        show: false
      },
      smooth: true
    })

    return (
      <div className='echart temp-stripes global'>
        <h3>{this.props.title}</h3>
        <h5>{this.props.subtitle}</h5>
        <ReactEcharts
          ref={e => {
            this.echarts_react = e
          }}
          onEvents={this.handleEvents}
          option={this.state.chartOptions}
          opts={{ renderer: 'canvas' }}
          notMerge
          lazyUpdate
          theme='ta_theme'
          style={{ height: this.state.isMobile ? '20em' : '23em' }}
        />
        <div className='scale'>
          <div className='wrapper'>
            <div
              className={this.state.highlightTemp === -2 ? 'box active' : 'box'}
              style={{ backgroundColor: '#081f45' }}
              onMouseEnter={() => this.setHighlight(-2)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -1.3 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#234b7b' }}
              onMouseEnter={() => this.setHighlight(-1.3)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -1.1 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#366492' }}
              onMouseEnter={() => this.setHighlight(-1.1)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -0.8 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#6697bd' }}
              onMouseEnter={() => this.setHighlight(-0.8)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -0.6 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#83b0cf' }}
              onMouseEnter={() => this.setHighlight(-0.6)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -0.3 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#a3cadf' }}
              onMouseEnter={() => this.setHighlight(-0.3)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -0.2 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#c8e3ef' }}
              onMouseEnter={() => this.setHighlight(-0.2)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === -0.1 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#f1fcff' }}
              onMouseEnter={() => this.setHighlight(-0.1)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 0.1 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#ffffe1' }}
              onMouseEnter={() => this.setHighlight(0.1)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 0.2 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#fed5a0' }}
              onMouseEnter={() => this.setHighlight(0.2)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 0.3 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#fda67a' }}
              onMouseEnter={() => this.setHighlight(0.3)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 0.6 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#ef7967' }}
              onMouseEnter={() => this.setHighlight(0.6)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 0.8 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#d45059' }}
              onMouseEnter={() => this.setHighlight(0.8)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 1.1 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#b22d45' }}
              onMouseEnter={() => this.setHighlight(1.1)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={
                this.state.highlightTemp === 1.3 ? 'box active' : 'box'
              }
              style={{ backgroundColor: '#8a102b' }}
              onMouseEnter={() => this.setHighlight(1.3)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
            <div
              className={this.state.highlightTemp === 2 ? 'box active' : 'box'}
              style={{ backgroundColor: '#5e0204' }}
              onMouseEnter={() => this.setHighlight(2)}
              onMouseLeave={() => this.setHighlight(9999)}
            >
              &nbsp;
            </div>
          </div>
        </div>
        <div className='legends'>
          <div className='box'>
            <span className='left wide'>&lt;</span>
          </div>
          <div className='box'>
            <span className='left wide'>-1.5</span>
          </div>
          <div className='box'>
            <span className='left'>-1.25</span>
          </div>
          <div className='box'>
            <span className='left narrow'>-1</span>
          </div>
          <div className='box'>
            <span className='left narrow'>-0.75</span>
          </div>
          <div className='box'>
            <span className='left minimal'>-0.5</span>
          </div>
          <div className='box'>
            <span className='left minimal'>-0.25</span>
          </div>
          <div className='box'>
            <span>-0.125</span>
          </div>
          <div className='box'>
            <span>0</span>
          </div>
          <div className='box'>
            <span>+0.125</span>
          </div>
          <div className='box'>
            <span className='right minimal'>+0.25</span>
          </div>
          <div className='box'>
            <span className='right minimal'>+0.5</span>
          </div>
          <div className='box'>
            <span className='right minimal'>+0.75</span>
          </div>
          <div className='box'>
            <span className='right narrow'>+1</span>
          </div>
          <div className='box'>
            <span className='right narrow'>+1.25</span>
          </div>
          <div className='box'>
            <span className='right'>+1.5</span>
          </div>
          <div className='box'>
            <span className='right wide'>&gt;</span>
          </div>
        </div>
        <div className='source'>
          Quelle:{' '}
          {/* }
          <Link href='https://www.meteoschweiz.admin.ch/home/klima/schweizer-klima-im-detail/homogene-messreihen-ab-1864.html?region=Tabelle'>
            Meteoschweiz
          </Link>
        */}
          NOAA
        </div>
      </div>
    )
  }
}
